import type { ComponentType, ReactNode } from "react";
import classnames from "classnames";

import Styles from "./modal_scroll_content.module.scss";

export function ModalScrollContent({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <div className={classnames(Styles.container, className)}>{children}</div>;
}

export default function modalScrollContentHOC<Props extends Record<string, unknown>>(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Component: ComponentType<Props>,
): ComponentType<Props> {
  return function ModalScrollableContentWrapper(props) {
    return (
      <ModalScrollContent>
        <Component {...props} />
      </ModalScrollContent>
    );
  };
}
